//Please add the language resource
const recoveryApprove = {
  nodeName: '审批节点',
  approveUserName: '审批人',
  approveTime: '处理时间',
  approveComment: '审批意见',
  approveStatusName: '审批结果',
  msg:{
  }
};
export default recoveryApprove



// WEBPACK FOOTER //
// ./src/page/recovery/approve/lang/recoveryApprove.en.js